import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {type IAttributeVocabularyValue} from '../schema';

/**
 * `setAttributeVocabularyValue` request params
 * (what is used to send to server)
 */

export type SetAttributeVocabularyValueRequestOptions = {
	id: number;
	value: string;
};

/**
 * `setAttributeVocabularyValue` request
 * (what sets sent to the server)
 */
export type SetAttributeVocabularyValueRequest = [
	SetAttributeVocabularyValueRequestOptions['id'],
	SetAttributeVocabularyValueRequestOptions['value'],
];

/**
 * `setAttributeVocabularyValue` response
 * (what comes back from the server)
 */
export type SetAttributeVocabularyValueResponse =
	SuccessResponse<SetAttributeVocabularyValueResult>;

/**
 * `setAttributeVocabularyValue` result
 * (what is utilized from the server response)
 */
export type SetAttributeVocabularyValueResult = IAttributeVocabularyValue;

export const setAttributeVocabularyValueEndpoint =
	'setAttributeVocabularyValue';

/**
 * Set attribute vocabularies list
 * @param fetchParams Fetch params

 */
export const setAttributeVocabularyValue = async ({
	id,
	value,
}: SetAttributeVocabularyValueRequestOptions): Promise<SetAttributeVocabularyValueResult> => {
	const client = NetxQueryClient();

	const requestParams: SetAttributeVocabularyValueRequest = [id, value];

	return client
		.post<SetAttributeVocabularyValueResponse>(
			setAttributeVocabularyValueEndpoint,
			requestParams,
			{},
		)
		.then(getResponseResults);
};

export default setAttributeVocabularyValue;
